import React, { Component } from 'react'
import { connect } from 'react-redux'
import Link from 'redux-first-router-link'
import {
    getTextFilterCfg,
    getNumberFilterCfg,
} from '../grid/ColumnHelpers'
import IzraktenisMap from '../karte/IzraktenisMap'
import { urbumuAtradnesSarakstsStyle, urbumuAtradnesLegend } from '../karte/urbumuAtradnesStyles'
import SplitterLayout from 'react-splitter-layout'
import { guiSet, addUrlQuery } from '../../actions/uiActions'
import { pazemesUdenuBilanceSelected } from '../../actions/hidrogeoActions'
import Grid from '../grid/Grid'
import BBoxFilterButtonToUrl from '../grid/BBoxFilterButtonToUrl'
import { Button } from 'reactstrap'
import { format, parse, getYear } from 'date-fns'
import * as constants from '../../constants'
import { DateInputField } from '../forms/Form'
import { hasHigFullAccess } from '../../utils'

const thisYear = getYear(new Date())
const years = Array(3).fill().map((_, i) => {
    const year = thisYear - 2 + i
    return {
        year,
        no: format(new Date(year, 0, 1), constants.DATE_FORMAT),
        lidz: format(new Date(year, 11, 31), constants.DATE_FORMAT)
    }
})

const htmlFormatter = (value) => {
    if (!value) return null
    return <span dangerouslySetInnerHTML={{ __html: value }} />
}

// lauki, ko ierobežotais skats (pazemes_udenu_bilance_list_ierobezots) neatgriež
const RESTRICTED_HIDDEN_COLUMNS = ['adrese', 'lietotajs']

const getColumns = (hasFullAccess) => [
    {
        dataField: 'atradne_numurs',
        text: 'Atradnes numurs',
        width: 120,
        formatter: (numurs) => numurs && hasFullAccess ? (
            <Link to={{ type: 'loc_urbumu_atradne', payload: { id: numurs } }}>
                {numurs}
            </Link>
        ) : (numurs || null),
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'gads',
        text: 'Gads',
        width: 100,
        filterCfg: getNumberFilterCfg()
    },
    {
        dataField: 'atradne_nosaukums',
        text: 'Atradnes nosaukums',
        width: 200,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'veids',
        text: 'Veids',
        width: 150,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'adrese',
        text: 'Adrese',
        width: 200,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'udens_horizonts',
        text: 'Ūdens nesējslānis',
        width: 150,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'pazemes_udens_objekts',
        text: 'Pazemes ūdensobjekts',
        width: 180,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'upju_baseins',
        text: 'Upju baseinu apsaimniekošanas apgabals',
        width: 180,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'lietotajs',
        text: 'Ūdens lietotājs',
        width: 150,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'pazemes_udenu_izmantosana',
        text: 'Pazemes ūdeņu izmantošanas mērķis',
        width: 180,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'lidz_1997_apstiprin_a',
        text: 'Apstiprinātie krājumi (m3/d) līdz 1997.gadam uz norādītā gada 1. janvāri, A kategorija',
        width: 240,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'lidz_1997_apstiprin_n',
        text: 'Apstiprinātie krājumi (m3/d) līdz 1997.gadam uz norādītā gada 1. janvāri, N kategorija',
        width: 240,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'sak_kraj_akc_a',
        text: 'Akceptētie krājumi (m3/d) uz norādītā gada 1. janvāri, A kategorija',
        width: 220,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'sak_kraj_akc_n',
        text: 'Akceptētie krājumi (m3/d) uz norādītā gada 1. janvāri, N kategorija',
        width: 220,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'izpetes_gads',
        text: 'Izpētes gads',
        width: 100,
        filterCfg: getNumberFilterCfg()
    },
    {
        dataField: 'urbumu_skaits',
        text: 'Urbumu skaits aprēķina shēmā',
        width: 130,
        filterCfg: getNumberFilterCfg()
    },
    {
        dataField: 'ieguve',
        text: 'Ieguve (m3/d)',
        width: 100,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'ieguves_urb_skaits',
        text: 'Ieguves urbumu skaits',
        width: 130,
        filterCfg: getNumberFilterCfg()
    },
    {
        dataField: 'kraj_izm_izpete_a',
        text: 'Krājumu izmaiņas (m3/d) norādītajā gadā: izpēte, A krājumi',
        width: 210,
        formatter: htmlFormatter,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'kraj_izm_izpete_n',
        text: 'Krājumu izmaiņas (m3/d) norādītajā gadā: izpēte, N krājumi',
        width: 210,
        formatter: htmlFormatter,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'kraj_izm_parrek_a',
        text: 'Krājumu izmaiņas (m3/d) norādītajā gadā: pārrēķins, A krājumi',
        width: 210,
        formatter: htmlFormatter,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'kraj_izm_parrek_n',
        text: 'Krājumu izmaiņas (m3/d) norādītajā gadā: pārrēķins, N krājumi',
        width: 210,
        formatter: htmlFormatter,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'atbilstiba_apr_kval_rad',
        text: 'Atbilstība aprēķinātajiem kvalitātes rādītājiem',
        width: 190,
        formatter: htmlFormatter,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'lim_pazemin_apr',
        text: 'Aprēķinātā līmeņa pazemināšanās (m)',
        width: 160,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'lim_pazemin_fakt',
        text: 'Faktiskā līmeņa pazemināšanās (m)',
        width: 160,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'beig_kraj_apst_a',
        text: 'Apstiprinātie krājumi (m3/d) līdz 1997.gadam uz nākamā gada 1. janvāri, A kategorija',
        width: 240,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'beig_kraj_apst_n',
        text: 'Apstiprinātie krājumi (m3/d) līdz 1997.gadam uz nākamā gada 1. janvāri, N kategorija',
        width: 240,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'beig_kraj_akc_a',
        text: 'Akceptētie krājumi (m3/d) uz nākamā gada 1. janvāri, A kategorija',
        width: 220,
        filterCfg: getTextFilterCfg()
    },
    {
        dataField: 'beig_kraj_akc_n',
        text: 'Akceptētie krājumi (m3/d) uz nākamā gada 1. janvāri, N kategorija',
        width: 220,
        filterCfg: getTextFilterCfg()
    },
].filter(c => hasFullAccess || !RESTRICTED_HIDDEN_COLUMNS.includes(c.dataField))

class PazemesUdenuBilanceSaraksts extends Component {

    constructor(props) {
        super(props)
        if (!props.query || (!props.query.pno && !props.query.plidz)) {
            props.addUrlQuery({ pno: years[0].no, plidz: years[0].lidz })
        }
    }

    mapPaneSizeChange = (h) => {
        this.props.guiSet('pazemes_udenu_bilance_saraksts_karte_height', h)
    }

    onChangePeriod = (fieldName, date) => {
        this.props.addUrlQuery({ [fieldName]: date ? format(date, constants.DATE_FORMAT) : undefined })
    }

    onYearBtnClick = (y) => () => {
        this.props.addUrlQuery({ pno: y.no, plidz: y.lidz })
    }

    render() {
        const { pazemesUdenuBilance, gui, pazemesUdenuBilanceSelected, query, user } = this.props
        const { list, selected, loading, count } = pazemesUdenuBilance
        const hasFullAccess = hasHigFullAccess(user)

        if (this.lastFullAccess !== hasFullAccess || !this.columns) {
            this.lastFullAccess = hasFullAccess
            this.columns = getColumns(hasFullAccess)
        }

        const vectorLayerCfgs = {
            atradnes: {
                title: 'Atradnes',
                features: list,
                styles: urbumuAtradnesSarakstsStyle,
                tooltipFunc: (feat) => `${feat.get('atradne_numurs')} - ${feat.get('atradne_nosaukums') || ''}`,
                selected,
                legend: urbumuAtradnesLegend
            }
        }

        const pno = query && query.pno ? parse(query.pno, constants.DATE_FORMAT, new Date()) : undefined
        const plidz = query && query.plidz ? parse(query.plidz, constants.DATE_FORMAT, new Date()) : undefined

        return (
            <SplitterLayout
                vertical
                percentage
                primaryIndex={1}
                secondaryInitialSize={gui.pazemes_udenu_bilance_saraksts_karte_height}
                onSecondaryPaneSizeChange={this.mapPaneSizeChange}
            >
                <IzraktenisMap mapId="pazemes_udenu_bilance_saraksts" vectorLayerCfgs={vectorLayerCfgs} />

                <Grid
                    onRowSelected={pazemesUdenuBilanceSelected}
                    loading={loading}
                    selectedId={selected}
                    dataList={list}
                    totalCount={count}
                    columns={this.columns}
                    exportViewname={hasFullAccess ? 'pazemes_udenu_bilance_list' : 'pazemes_udenu_bilance_list_ierobezots'}
                >
                    <b>Periods:</b>&nbsp;&nbsp;
                    <DateInputField
                        setFieldValue={this.onChangePeriod}
                        fieldName="pno"
                        currentVal={pno}
                        extraFieldProps={{ placeholder: 'No' }}
                    />
                    &nbsp;-&nbsp;
                    <DateInputField
                        setFieldValue={this.onChangePeriod}
                        fieldName="plidz"
                        currentVal={plidz}
                        extraFieldProps={{ placeholder: 'Līdz' }}
                    />
                    &nbsp;&nbsp;
                    {years.map(y => (
                        <Button
                            key={y.year}
                            onClick={this.onYearBtnClick(y)}
                            color={query && query.pno === y.no && query.plidz === y.lidz ? 'primary' : 'secondary'}
                        >
                            {y.year}
                        </Button>
                    ))}
                    <BBoxFilterButtonToUrl />
                </Grid>
            </SplitterLayout>
        )
    }
}

const mapStateToProps = ({ pazemesUdenuBilance, gui, location, user }) => ({
    pazemesUdenuBilance,
    gui,
    query: location.query,
    user
})

export default connect(mapStateToProps, { pazemesUdenuBilanceSelected, guiSet, addUrlQuery })(PazemesUdenuBilanceSaraksts)